const LOAD_DETAIL_MINI_ENGLISH           = 'LOAD_DETAIL_MINI_ENGLISH'
const LOAD_DETAIL_MINI_ENGLISH_SUCCESS   = 'LOAD_DETAIL_MINI_ENGLISH_SUCCESS'
const LOAD_DETAIL_MINI_ENGLISH_FAILED    = 'LOAD_DETAIL_MINI_ENGLISH_FAILED'
const UNMOUNT_DETAIL_MINI_ENGLISH        = 'UNMOUNT_DETAIL_MINI_ENGLISH'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const detailMiniEnglishReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_MINI_ENGLISH:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_MINI_ENGLISH_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_MINI_ENGLISH_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_MINI_ENGLISH:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default detailMiniEnglishReducer;